/** ***********
*
* <filter.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
 * All rights reserved.
**************/

import { NgModule } from '@angular/core';
import { FilterComponent } from './filter.component';
import { AppMaterialModule } from 'src/app/material.modules';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations : [
        FilterComponent
    ],

    imports : [
        AppMaterialModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule.forChild({ extend: true }),
        SharedModule
    ],

    exports : [
        FilterComponent
    ]
})

export class FilterModule { }
